import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/organisms/header/header';
import routes from './constants/routes';

const GuestWrapper = ({ children, location }) => {
  const [compTop, setCompTop] = useState(100);
  const [withoutHeader, setWithoutHeader] = useState('loading');

  const pageTitle =
    Object.values(routes).find(el => el.pathname === location.pathname)?.pageTitle || 'Homepage';

  const changeWindow = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 172) {
      setCompTop(136);
    } else if (windowWidth < 500) {
      setCompTop(136);
    } else if (windowWidth < 610) {
      setCompTop(180);
    } else if (windowWidth < 1098) {
      setCompTop(146);
    } else {
      setCompTop(109);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', changeWindow);
    return () => {
      window.removeEventListener('resize', changeWindow);
    };
  }, []);

  useEffect(() => {
    if (location?.pathname.includes(['admin'])) {
      setWithoutHeader(true);
      setCompTop(0);
    } else {
      setWithoutHeader(false);
      changeWindow();
    }
  }, [location]);

  return (
    <>
      <div>
        <title>{pageTitle}</title>
      </div>
      {!withoutHeader && <Header />}
      <div style={{ position: 'relative', top: `${compTop}px` }}>{children}</div>
    </>
  );
};

export default React.memo(withRouter(GuestWrapper));
